import { create } from 'zustand';
import { omit } from 'es-toolkit';
import { persist, createJSONStorage } from 'zustand/middleware';
import { APP_VERSION } from '@/const';

type TStoreFlow = {
    id: string;
    selectedSkillId: string;
};

type IDesignerState = {
    flows: Record<string, TStoreFlow | undefined>;
    selectSkill: (flowId: string, skillId: string) => void;
    flush: () => void;
    skillScripts: Record<string, string | undefined>;
    setSkillScript: (skillId: string, skillScript?: string) => void;
    clearSkillScripts: (skillIds: string[]) => void;
};

const initialState = {
    flows: {},
    skillScripts: {}
};

const useDesignerStore = create<IDesignerState>()(
    persist(
        (set) => ({
            ...initialState,
            selectSkill: (flowId, skillId) => {
                if (!flowId || !skillId) {
                    return;
                }
                set((state) => ({
                    flows: {
                        ...state.flows,
                        [flowId]: {
                            ...state.flows[flowId],
                            selectedSkillId: skillId
                        } as TStoreFlow
                    }
                }));
            },
            setSkillScript: (skillId, skillScript) => {
                if (skillId) {
                    set((state) => ({
                        skillScripts: {
                            ...state.skillScripts,
                            [skillId]: skillScript
                        }
                    }));
                }
            },
            clearSkillScripts: (skillIds) => {
                set((state) => {
                    return {
                        skillScripts: omit(state.skillScripts, skillIds)
                    };
                });
            },
            flush: () => {
                set(initialState);
            }
        }),
        {
            name: 'designer-store',
            storage: createJSONStorage(() => globalThis.sessionStorage),
            partialize: (state) => state,
            version: APP_VERSION
        }
    )
);

export default useDesignerStore;
